import { render } from "./VueExDemo.vue?vue&type=template&id=7a5fda6b"
import script from "./VueExDemo.vue?vue&type=script&lang=js"
export * from "./VueExDemo.vue?vue&type=script&lang=js"

import "./VueExDemo.vue?vue&type=style&index=0&id=7a5fda6b&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__